import { useCallback, useState } from "react";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { useAuth } from "src/contexts/auth-provider";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { UPDATE_MODIFIER_ITEM } from "src/constants/mutations";
import { successToast } from "src/utils/toasts";
import { UpdateModifierItemInput, ModifierItem } from "src/interfaces/modifier.interface";
import { useDispatch } from "react-redux";
import { update_modifier_item } from "src/store/features/modifier-items-slice";

export const useUpdateModifierItem = () => {
  const { axBe } = useAxiosInterceptor();
  const { hasRestaurant } = useAuth();
  const dispatch = useDispatch();

  const [isUpdatingModifierItem, setIsUpdatingModifierItem] = useState(false);

  const updateModifierItem = useCallback(async (updateModifierItemInput: UpdateModifierItemInput) => {
    if (!hasRestaurant?.correlationId) {
      return null;
    }

    setIsUpdatingModifierItem(true);

    try {
      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: UPDATE_MODIFIER_ITEM,
        variables: {
          updateModifierItemInput,
        },
      });

      if (data?.data?.updateModifierItem) {
        const updatedModifierItem: ModifierItem = data.data.updateModifierItem;
        dispatch(update_modifier_item(updatedModifierItem));
        successToast("Modifier item updated successfully");
      } else {
        throw new Error("Failed to update modifier item");
      }
    } catch (err) {
      console.error("Error updating modifier item:", err);
      return null;
    } finally {
      setIsUpdatingModifierItem(false);
    }
  }, [axBe, hasRestaurant?.correlationId, dispatch]);

  return {
    updateModifierItem,
    isUpdatingModifierItem,
  };
};
